<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>End Of Day Report</h1>
    </div>
</div>

<div class="card mb-3 mt-2">
    <div class="card-body bg-light p-3">
        <div class="input-group input-group-sm w-lg-50">
            <div class="input-group-prepend">
                <button class="btn btn-secondary" [disabled]="reportBusy" (click)="filterSubmit()">{{ reportBusy ? 'Search...' : 'Filter' }}</button>
            </div>
            <input
                class="form-control input-datepicker-icon report-date-postision"
                placeholder="dd/mm/yyyy"
                name="dp"
                [(ngModel)]="model"
                ngbDatepicker
                #d="ngbDatepicker"
                (click)="d.toggle()"
            />
        </div>
    </div>
</div>

<div class="spinner"></div>
<div class="card end-of-day-report">
    <div class="label">{{ endOfDayReport.branchName }}</div>
    <div class="total-cash">
        <div class="text">Cash</div>
        <div class="value">{{ endOfDayReport.totalCash | number: '1.2-2' }}</div>
    </div>
    <div class="total-credit">
        <div class="text">Credit</div>
        <div class="value">{{ endOfDayReport.totalCredit | number: '1.2-2' }}</div>
    </div>
    <div class="total">
        <div class="text">Total</div>
        <div class="value">{{ endOfDayReport.total | number: '1.2-2' }}</div>
    </div>
</div>
